import { Card, CardContent, Typography } from '@mui/material'

import useSimpleCardStyles from './SimpleCard.styles'
import { SimpleCardProps } from './SimpleCard.types'

const SimpleCard = ({ variant, title, description }: SimpleCardProps) => {
  const styles = useSimpleCardStyles(variant)

  const titleWordsArray = title.split(' ')

  return (
    <Card sx={styles.root}>
      <CardContent sx={styles.cardContent}>
        <Typography variant="h4" component="h3" sx={styles.title}>
          {titleWordsArray.map((word, index) => (
            <span key={index}>{word}</span>
          ))}
        </Typography>
        <Typography variant="subtitle2" component="p">
          {description}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default SimpleCard
